var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hasErrors)?_c('PresentPublication',{on:{"PresentPublicationEvent":_vm.presentPublicationEventHandler}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }